import Business from '@/pages/Business'

// export default {
//     path: '/:id',
//     name: 'Business',
//     component: Business
// }

export default {
    path: '',
    component: Business,
    children: [
        {
            path: '/:id',
            name: 'Business',
            component: Business
        },
        {
            path: '/:id/:ref',
            name: 'Item',
            component: Business,
        },
        {
            path: '/:id/checkout/:ref',
            name: 'Checkout',
            component: Business,
        },
        {
            path: '/:id/reorder/:ref',
            name: 'ReOrder',
            component: Business,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/business.js